export class Header {

    public constructor(init?: Partial<Header>) {
        Object.assign(this, init);
    }

    name?: string | null;
    icon?: string | null;
    link?: string | null;
    visible?: boolean;
}